module.exports = __webpack_public_path__ + "static/media/assistant.454a510d.png";